import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import ReactDatetime from 'react-datetime';

interface Props {
  name: string;
  label?: ReactNode;
  placeholder?: string;
  required?: boolean;
  timeFormat?: boolean | string;
  validate?: (value: any) => string | undefined;
  closeOnSelect?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  dateFormat?: boolean | string;
  onDateChange?: (date: any) => void;
  displayDatetime?: string;
  forceDirty?: boolean;
}

export const DateTimeField: FC<Props> = ({
  name,
  label,
  placeholder = 'Select Date',
  required = false,
  timeFormat = false,
  closeOnSelect = true,
  validate,
  readOnly = false,
  disabled = false,
  dateFormat = false,
  onDateChange,
  displayDatetime,
  forceDirty = false,
  ...fieldProps
}) => {
  return (
    <Field name={name} validate={validate} {...fieldProps}>
      {({ input, meta }) => {
        const handleChangeDate = (date: any) => {
          if (onDateChange) {
            onDateChange(date);
            return;
          }

          const formattedTime = date.format('LT');
          input.onChange(formattedTime);
        };

        const getDisplayValue = () => {
          if (!input.value) return '';
          if (displayDatetime) return displayDatetime;

          return input.value;
        };

        const isFieldDirty = meta.dirty || meta.touched;
        const shouldConsiderDirty = isFieldDirty || forceDirty;
        const shouldShowError = (meta.error || meta.submitError) && shouldConsiderDirty;

        return (
          <div className={classNames('form-group', { 'has-danger': shouldShowError })}>
            {label && (
              <label htmlFor={name}>
                {label}
                {required && <span className="required"> *</span>}
              </label>
            )}
            <ReactDatetime
              inputProps={{
                className: 'form-control picker-input',
                placeholder,
                readOnly,
                disabled,
              }}
              onChange={handleChangeDate}
              value={getDisplayValue()}
              closeOnSelect={closeOnSelect}
              timeFormat={timeFormat}
              dateFormat={dateFormat}
            />
            {shouldShowError && (
              <label htmlFor={name} className="error">
                {meta.error || meta.submitError}
              </label>
            )}
          </div>
        );
      }}
    </Field>
  );
};
